import { stringify } from 'query-string'
import UrlPattern from 'url-pattern'
export default function prepareUrl (url, params, query, options = { arrayFormat: 'comma' }) {
  /*
    Url string example:
    http://foo.bar/recource/:id/subrecource/:subid
   */
  let _url = new UrlPattern(url)
  _url = _url.stringify(params)

  let resultQuery = stringify(query, options)
  _url = `${_url}${resultQuery.length ? '?' : ''}${resultQuery}`

  return _url
}
